import 'assets/styles/keen/theme01/layout/aside/dark.css';
import AppConfigs from 'general/constants/AppConfigs';
import AppResource from 'general/constants/AppResource';
import UserHelper from 'general/helpers/UserHelper';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import './style.scss';
import { getRole } from 'services/auth/permission';
import PreferenceKeys from 'general/constants/PreferenceKeys';
import Swal from 'sweetalert2';
import { BsCart4 } from "react-icons/bs";
import { AiOutlineHome } from "react-icons/ai";
import { WiDaySunnyOvercast } from "react-icons/wi";
import { GiCardPickup } from "react-icons/gi";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { IoAnalyticsSharp } from "react-icons/io5";
import { IoSettingsOutline } from "react-icons/io5";
import { FaUsers } from "react-icons/fa6";
import { LuUser2 } from "react-icons/lu";
import { PiStorefront } from "react-icons/pi";
import { GiBlackBook } from "react-icons/gi";
import { RiCompass3Line } from "react-icons/ri";
import { VscSymbolEvent } from "react-icons/vsc";
import { PiWebhooksLogoDuotone } from "react-icons/pi";
import { CgCommunity } from "react-icons/cg";
import { GiFamilyTree } from "react-icons/gi";
import { BiHomeAlt } from "react-icons/bi";

function KT01Sidebar(props) {
  // MARK: --- Params ---
  const router = useRouter();
  const pathName = router.pathname;
  const { t } = useTranslation();
  const currentAccount = useSelector((state) => state.auth.current);
  const [screenCodes, set_screenCodes] = useState([]);
  const navigate = useNavigate();

  const itemms = [
    {
      type: 'item',
      text: "Trang chủ",
      icon: <BiHomeAlt />,
      path: 'Home',
      children: [

      ],
    },
    {
      type: 'group',
      text: "Bán hàng",
      icon: <BiHomeAlt />,
      path: 'Home',
      children: [
        {
          type: 'item',
          text: t("SalesStatistics"),
          icon: <BsCart4 />,
          path: '',
          item: "salesstatistics",
          children: [
            {
              type: 'item',
              text: t("ReportRevenue"),
              icon: "fas fa-analytics",
              path: 'salesreport',
            },
            {
              type: 'item',
              text: t("OrderStatistics"),
              icon: "fas fa-analytics",
              path: 'OrderStatistics',
            },
            {
              type: 'item',
              text: "Cuộc gọi telesale",
              icon: "fas fa-phone",
              path: 'CallHistoryReport',
            },
          ]
        },
      ],
    },
    {
      type: 'group',
      text: "Online store",
      icon: <BiHomeAlt />,
      path: 'Home',
      children: [
        {
          type: 'item',
          text: "Online store ",
          icon: <PiStorefront />,
          path: '',
          item: "salesstatistics",
          children: [
            {
              type: 'item',
              text: "Thống kê",
              icon: "fas fa-analytics",
              path: 'salesreport',
            },
          ]
        },
      ],
    },
    {
      type: 'group',
      text: "Tài khoản & người dùng",
      icon: <BiHomeAlt />,
      path: 'Home',
      children: [
        {
          type: 'item',
          text: "Online store ",
          icon: <PiStorefront />,
          path: '',
          item: "salesstatistics",
          children: [
            {
              type: 'item',
              text: "Tài khoản & người dùng",
              icon: <LuUser2 />,
              path: '',
              item: "NguoiDung",
              children: [
                {
                  type: 'item',
                  text: "Người dùng mới",
                  icon: 'fas fa-analytics',
                  path: 'NguoiDungMoi',
                },
                {
                  type: 'item',
                  text: "Tài khoản Lịch Việt mới",
                  icon: 'fas fa-analytics',
                  path: 'ReportNewAccountsStatistics',
                },
                {
                  type: 'item',
                  text: "Đăng nhập",
                  icon: 'fas fa-analytics',
                  path: 'ReportLoginStatistics',
                },
                {
                  type: 'item',
                  text: "Thành viên gia đình",
                  icon: 'fas fa-analytics',
                  path: 'FamilyMemberReport',
                }
              ],
            },
          ]
        },
      ],
    },
    {
      type: 'group',
      text: "Sử dụng dịch vụ & tính năng",
      icon: <BiHomeAlt />,
      path: 'Home',
      children: [
        {
          type: 'item',
          text: "Online store ",
          icon: <PiStorefront />,
          path: '',
          item: "salesstatistics",
          children: [
            {
              type: 'item',
              text: "Tài khoản & người dùng",
              icon: <LuUser2 />,
              path: '',
              item: "NguoiDung",
              children: [
                {
                  type: 'item',
                  text: "Chọn ngày tốt",
                  icon: <WiDaySunnyOvercast />,
                  path: '',
                  item: "gooddaystatistics",
                  children: [
                    {
                      type: 'item',
                      text: "Sử dụng dịch vụ",
                      icon: "fas fa-analytics",
                      path: 'usetheservice',
                    },
                    {
                      type: 'item',
                      text: "Đánh giá dịch vụ",
                      icon: "fas fa-analytics",
                      path: 'servicereviews',
                    },
                  ]
                },
                {
                  type: 'item',
                  text: "Gieo quẻ (lục hào)",
                  icon: <GiCardPickup />,
                  path: '',
                  item: "gooddaystatistics",
                  children: [
                    {
                      type: 'item',
                      text: "Sử dụng dịch vụ",
                      icon: "fas fa-analytics",
                      path: 'GieoQueLucHao',
                    },
                  ]
                },
                {
                  type: 'item',
                  text: "Tử vi",
                  icon: <GiBlackBook />,
                  path: '',
                  item: "gooddaystatistics",
                  children: [
                    {
                      type: 'item',
                      text: "Sử dụng dịch vụ",
                      icon: "fas fa-analytics",
                      path: 'GieoQueLucHao',
                    },
                  ]
                },
                {
                  type: 'item',
                  text: "Phong thuỷ",
                  icon: <RiCompass3Line />,
                  path: '',
                  item: "gooddaystatistics",
                  children: [
                    {
                      type: 'item',
                      text: "Sử dụng dịch vụ",
                      icon: "fas fa-analytics",
                      path: 'GieoQueLucHao',
                    },
                  ]
                },
                {
                  type: 'item',
                  text: "Sự kiện",
                  icon: <VscSymbolEvent />,
                  path: '',
                  item: "gooddaystatistics",
                  children: [
                    {
                      type: 'item',
                      text: "Sử dụng dịch vụ",
                      icon: "fas fa-analytics",
                      path: 'GieoQueLucHao',
                    },
                  ]
                },
                {
                  type: 'item',
                  text: "Thần số học",
                  icon: <PiWebhooksLogoDuotone />,
                  path: '',
                  item: "gooddaystatistics",
                  children: [
                    {
                      type: 'item',
                      text: "Sử dụng dịch vụ",
                      icon: "fas fa-analytics",
                      path: 'GieoQueLucHao',
                    },
                  ]
                },
                {
                  type: 'item',
                  text: "Cộng đồng",
                  icon: <CgCommunity />,
                  path: '',
                  item: "gooddaystatistics",
                  children: [
                    {
                      type: 'item',
                      text: "Sử dụng dịch vụ",
                      icon: "fas fa-analytics",
                      path: 'GieoQueLucHao',
                    },
                  ]
                },
                {
                  type: 'item',
                  text: "Gia phả",
                  icon: <GiFamilyTree />,
                  path: '',
                  item: "gooddaystatistics",
                  children: [
                    {
                      type: 'item',
                      text: "Sử dụng dịch vụ",
                      icon: "fas fa-analytics",
                      path: 'GieoQueLucHao',
                    },
                  ]
                },
              ],
            },
          ]
        },
      ],
    },
    {
      type: 'group',
      text: "Báo cáo vận hành",
      icon: <BiHomeAlt />,
      path: 'Home',
      children: [
        {
          type: 'item',
          text: "Online store ",
          icon: <PiStorefront />,
          path: '',
          item: "salesstatistics",
          children: [
            {
              type: 'item',
              text: "Báo cáo vận hành khác",
              icon: <HiOutlineDocumentReport />,
              path: '',
              item: "BaoCaoVanHanhKhac",
              children: [
                {
                  type: 'item',
                  text: "Zalo Notification Service",
                  icon: "fas fa-analytics",
                  path: 'baocaozalo',
                },
                {
                  type: 'item',
                  text: "Truy cập API",
                  icon: "fas fa-analytics",
                  path: 'ApiAccessReport',
                },
              ]
            },
          ]
        },
      ],
    },
    {
      type: 'group',
      text: "ManageCustomerBase",
      icon: <BiHomeAlt />,
      path: 'Home',
      children: [
        {
          type: 'item',
          text: "Online store ",
          icon: <PiStorefront />,
          path: '',
          item: "salesstatistics",
          children: [
            {
              type: 'item',
              text: "Báo cáo vận hành khác",
              icon: <HiOutlineDocumentReport />,
              path: '',
              item: "BaoCaoVanHanhKhac",
              children: [
                {
                  type: 'item',
                  text: t("CustomerSet"),
                  icon: <FaUsers />,
                  path: '',
                  item: "ManageCustomerBase",
                  children: [
                    {
                      type: 'item',
                      text: t("ManageCustomerBase"),
                      icon: "",
                      path: 'CustomerSet',
                    },
                  ]
                },
                {
                  type: 'item',
                  text: "Phân tích khách hàng",
                  icon: <IoAnalyticsSharp />,
                  path: '',
                  item: "PhanTichTapKhachHang",
                  children: [
                    {
                      type: 'item',
                      text: "Tổng quan khách hàng",
                      icon: 'fas fa-analytics',
                      path: 'CustomersOverview',
                    },
                    {
                      type: 'item',
                      text: "Phân tích tập khách hàng",
                      icon: 'fas fa-analytics',
                      path: 'PhanTichTapKhachHang',
                    },
                    {
                      type: 'item',
                      text: "Tra cứu khách hàng 360",
                      icon: 'fas fa-analytics',
                      path: 'PhanTichTapKhachHang',
                    },
                    {
                      type: 'item',
                      text: "Phễu khách hàng",
                      icon: 'fas fa-analytics',
                      path: 'PhanTichTapKhachHang',
                    },
                    {
                      type: 'item',
                      text: "Hành trình khách hàng",
                      icon: 'fas fa-analytics',
                      path: 'PhanTichTapKhachHang',
                    },
                  ]
                },
              ]
            },
          ]
        },
      ],
    },
  ];

  const menuItems = useMemo(() => {
    return [
      {
        type: 'item',
        text: t("Home"),
        icon: <BiHomeAlt />,
        path: 'Home',
        // item: "salesreport",
      },
      {
        type: 'section',
        text: "Bán hàng",
        item: "salesstatistics"
      },
      {
        type: 'item',
        text: t("SalesStatistics"),
        icon: <BsCart4 />,
        path: '',
        item: "salesstatistics",
        subMenuItems: [
          {
            type: 'item',
            text: t("ReportRevenue"),
            icon: "fas fa-analytics",
            path: 'salesreport',
          },
          {
            type: 'item',
            text: t("OrderStatistics"),
            icon: "fas fa-analytics",
            path: 'OrderStatistics',
          },
          {
            type: 'item',
            text: "Cuộc gọi telesale",
            icon: "fas fa-phone",
            path: 'CallHistoryReport',
          },
          {
            type: 'item',
            text: "Quản lý số liệu chiến dịch",
            icon: "fas fa-analytics",
            path: 'campaign-metrics',
          },
        ]
      },
      {
        type: 'section',
        text: "Online store",
        item: "OnlineStore"
      },
      {
        type: 'item',
        text: "Online store",
        icon: <PiStorefront />,
        path: '',
        item: "OnlineStore",
        subMenuItems: [
          {
            type: 'item',
            text: "Thống kê MiniApp",
            icon: "fas fa-analytics",
            path: 'OnlineStore',
          },
          {
            type: 'item',
            text: "Kích hoạt năng lượng",
            icon: "fas fa-analytics",
            path: 'EnergyActivation',
          },
        ]
      },
      {
        type: 'section',
        text: "Tài khoản & người dùng",
        item: "ManageCustomerBase"
      },
      {
        type: 'item',
        text: "Tài khoản & người dùng",
        icon: <LuUser2 />,
        path: '',
        item: "NguoiDung",
        subMenuItems: [
          {
            type: 'item',
            text: "Người dùng mới",
            icon: 'fas fa-analytics',
            path: 'NguoiDungMoi',
          },
          {
            type: 'item',
            text: "Tài khoản Lịch Việt mới",
            icon: 'fas fa-analytics',
            path: 'ReportNewAccountsStatistics',
          },
          {
            type: 'item',
            text: "Đăng nhập",
            icon: 'fas fa-analytics',
            path: 'ReportLoginStatistics',
          },
          {
            type: 'item',
            text: "Thành viên gia đình",
            icon: 'fas fa-analytics',
            path: 'FamilyMemberReport',
          },
          {
            type: 'item',
            text: "Đăng ký dịch vụ",
            icon: 'fas fa-analytics',
            path: 'PremiumReport',
          }
        ],
      },
      {
        type: 'section',
        text: "Sử dụng dịch vụ & tính năng",
        item: "sudungdichvuvatinhnang"
      },
      {
        type: 'item',
        text: "Chọn ngày tốt",
        icon: <WiDaySunnyOvercast />,
        path: '',
        item: "gooddaystatistics",
        subMenuItems: [
          {
            type: 'item',
            text: "Sử dụng dịch vụ",
            icon: "fas fa-analytics",
            path: 'usetheservice',
          },
          {
            type: 'item',
            text: "Đánh giá dịch vụ",
            icon: "fas fa-analytics",
            path: 'servicereviews',
          },
        ]
      },
      {
        type: 'item',
        text: "Gieo quẻ (lục hào)",
        icon: <GiCardPickup />,
        path: '',
        item: "gooddaystatistics",
        subMenuItems: [
          {
            type: 'item',
            text: "Sử dụng dịch vụ",
            icon: "fas fa-analytics",
            path: 'GieoQueLucHao',
          },
        ]
      },
      {
        type: 'item',
        text: "Tử vi",
        icon: <GiBlackBook />,
        path: '',
        item: "TuVi",
        subMenuItems: [
          {
            type: 'item',
            text: "Sử dụng dịch vụ",
            icon: "fas fa-analytics",
            path: 'sudungdichvutuvi',
          },
        ]
      },
      {
        type: 'item',
        text: "Phong thuỷ",
        icon: <RiCompass3Line />,
        path: '',
        item: "phongthuy",
        subMenuItems: [
          {
            type: 'item',
            text: "Sử dụng dịch vụ",
            icon: "fas fa-analytics",
            path: 'sudungdichvuphongthuy',
          },
        ]
      },
      {
        type: 'item',
        text: "Sự kiện",
        icon: <VscSymbolEvent />,
        path: '',
        item: "sukien",
        subMenuItems: [
          {
            type: 'item',
            text: "Sử dụng dịch vụ",
            icon: "fas fa-analytics",
            path: 'sudungdichvusukien',
          },
        ]
      },
      {
        type: 'item',
        text: "Thần số học",
        icon: <PiWebhooksLogoDuotone />,
        path: '',
        item: "thansohoc",
        subMenuItems: [
          {
            type: 'item',
            text: "Sử dụng dịch vụ",
            icon: "fas fa-analytics",
            path: 'sudungdichvuthansohoc',
          },
        ]
      },
      {
        type: 'item',
        text: "Cộng đồng",
        icon: <CgCommunity />,
        path: '',
        item: "congdong",
        subMenuItems: [
          {
            type: 'item',
            text: "Sử dụng dịch vụ",
            icon: "fas fa-analytics",
            path: 'sudungdichvucongdong',
          },
        ]
      },
      {
        type: 'item',
        text: "Gia phả",
        icon: <GiFamilyTree />,
        path: '',
        item: "giapha",
        subMenuItems: [
          {
            type: 'item',
            text: "Sử dụng dịch vụ",
            icon: "fas fa-analytics",
            path: 'sudungdichvugiapha',
          },
        ]
      },
      {
        type: 'section',
        text: "Báo cáo vận hành",
        item: "baocaovanhanh"
      },
      {
        type: 'item',
        text: "Báo cáo vận hành khác",
        icon: <HiOutlineDocumentReport />,
        path: '',
        item: "BaoCaoVanHanhKhac",
        subMenuItems: [
          {
            type: 'item',
            text: "Zalo Notification Service",
            icon: "fas fa-analytics",
            path: 'baocaozalo',
          },
          {
            type: 'item',
            text: "Truy cập API",
            icon: "fas fa-analytics",
            path: 'ApiAccessReport',
          },

        ]
      },
      {
        type: 'section',
        text: t("ManageCustomerBase"),
        item: "ManageCustomerBase"
      },
      {
        type: 'item',
        text: t("CustomerSet"),
        icon: <FaUsers />,
        path: '',
        item: "ManageCustomerBase",
        subMenuItems: [
          {
            type: 'item',
            text: t("ManageCustomerBase"),
            icon: "",
            path: 'CustomerSet',
          },
        ]
      },
      {
        type: 'item',
        text: "Phân tích khách hàng",
        icon: <IoAnalyticsSharp />,
        path: '',
        item: "PhanTichTapKhachHang",
        subMenuItems: [
          {
            type: 'item',
            text: "Tổng quan khách hàng",
            icon: 'fas fa-analytics',
            path: 'CustomersOverview',
          },
          {
            type: 'item',
            text: "Phân tích tập khách hàng",
            icon: 'fas fa-analytics',
            path: 'PhanTichTapKhachHang',
          },
          {
            type: 'item',
            text: "Tra cứu khách hàng 360",
            icon: 'fas fa-analytics',
            path: 'PhanTichTapKhachHang',
          },
          {
            type: 'item',
            text: "Phễu khách hàng",
            icon: 'fas fa-analytics',
            path: 'PhanTichTapKhachHang',
          },
          {
            type: 'item',
            text: "Hành trình khách hàng",
            icon: 'fas fa-analytics',
            path: 'PhanTichTapKhachHang',
          },
        ]
      },
      {
        type: 'section',
        text: t("SystemManagement"),
        item: "SystemManagement"
      },
      {
        type: 'item',
        text: t("System"),
        icon: <IoSettingsOutline />,
        path: '',
        item: "SystemManagement",
        subMenuItems: [{
          type: 'item',
          text: t("UserAdministration"),
          icon: 'fas fa-analytics',
          path: 'UserManagement',
        },
        {
          type: 'item',
          text: t("Roles"),
          icon: "",
          path: 'AuthorityRole',
        },
        ]
      },
    ];
  }, [currentAccount]);

  // MARK: --- Hooks ---
  useEffect(() => {
    // Init Aside
    if (KTLayoutAside !== undefined) {
      KTLayoutAside.init('kt_aside');
    }

    // Init Aside Toggle
    if (KTLayoutAsideToggle !== undefined) {
      KTLayoutAsideToggle.init('kt_aside_toggle');
    }

    // Init Aside Menu
    if (KTLayoutAsideMenu !== undefined) {
      KTLayoutAsideMenu.init('kt_aside_menu');
    }
  }, []);

  const [items, setItems] = useState([]);
  useEffect(() => {
    const InitPermission = async () => {
      try {
        const res = await getRole(localStorage.getItem(PreferenceKeys.savedLoginAccount));

        let lstitem = [];
        let screenCodes = [];
        res.data.data.screenCodes.split(';').map((item) => {
          if (item.includes(":")) {
            lstitem.push(item.split(':')[0]);
            screenCodes.push(...item.split(':')[1].split(','));
          } else {
            screenCodes.push(item);
          }
        });

        setItems(lstitem);
        set_screenCodes(screenCodes);
      } catch {
        await Swal.fire({
          title: t('Notification'),
          text: "Đã có vấn đề về quyền truy cập của tài khoản vui lòng liên hệ Admin!",
          icon: 'warning',
          confirmButtonText: t('Yes'),
          customClass: {
            confirmButton: 'btn btn-danger font-weight-bolder',
          }
        })
        navigate('/signin');
      }

    };
    InitPermission();
  }, []);

  useEffect(() => { }, [currentAccount]);
  // return (
  //   <div className="aside aside-left aside-fixed d-flex flex-column flex-row-auto" id="kt_aside">
  //     {/* Aside Header */}
  //     <div className="brand flex-column-auto">
  //       {/* logo */}
  //       <a className="brand-logo">
  //         {/* <img
  //           className="h-25px"
  //           src={AppResource.icons.icLogoICorpLight}
  //           alt="logo"
  //         // style={{
  //         //     filter: 'invert(96%) sepia(38%) saturate(59%) hue-rotate(118deg) brightness(109%) contrast(100%)',
  //         // }}
  //         /> */}
  //         <h1 style={{ color: 'white' }}>Lịch Việt</h1>
  //       </a>
  //       {/* button toggle */}
  //       <button className="brand-toggle btn btn-sm px-0 border-0" id="kt_aside_toggle">
  //         <span className="svg-icon svg-icon svg-icon-xl">
  //           <img src={AppResource.icons.keens.toggleRight} alt="toggle" />
  //         </span>
  //       </button>
  //     </div>

  //     {/* Aside Menu */}
  //     <div
  //       id="kt_aside_menu"
  //       className="aside-menu my-0"
  //       data-menu-scroll="1" // enable scroll
  //       data-menu-vertical="1"
  //     // data-menu-dropdown-timeout='500'
  //     >
  //       {/* Nav menu */}
  //       <ul className="menu-nav pt-0">
  //         {itemms.map((item, index) => {

  //           if (item?.type === 'group') {
  //             return (
  //               <li key={index} className="menu-section mt-0">
  //                 <h4 className="menu-text">{t(item?.text)}</h4>
  //               </li>
  //             );
  //           }
  //         })}
  //       </ul>
  //     </div>
  //   </div>
  // );

  return (
    <div className="aside aside-left aside-fixed d-flex flex-column flex-row-auto" id="kt_aside">
      {/* Aside Header */}
      <div className="brand flex-column-auto">
        {/* logo */}
        <a className="brand-logo">
          {/* <img
            className="h-25px"
            src={AppResource.icons.icLogoICorpLight}
            alt="logo"
          // style={{
          //     filter: 'invert(96%) sepia(38%) saturate(59%) hue-rotate(118deg) brightness(109%) contrast(100%)',
          // }}
          /> */}
          <h1 style={{ color: 'white' }}>Lịch Việt</h1>
        </a>
        {/* button toggle */}
        <button className="brand-toggle btn btn-sm px-0 border-0" id="kt_aside_toggle">
          <span className="svg-icon svg-icon svg-icon-xl">
            <img src={AppResource.icons.keens.toggleRight} alt="toggle" />
          </span>
        </button>
      </div>

      {/* Aside Menu */}
      <div
        id="kt_aside_menu"
        className="aside-menu my-0"
        data-menu-scroll="1" // enable scroll
        data-menu-vertical="1"
      // data-menu-dropdown-timeout='500'
      >
        {/* Nav menu */}
        <ul className="menu-nav pt-0">
          {menuItems.map((item, index) => {
            if (item?.type === 'item' && (items.includes(item?.item) || screenCodes.includes("*") || item?.path === "Home")) {
              const hasSubMenuLV1Items = item?.subMenuItems !== undefined;

              return (
                <li
                  key={index}
                  className={`menu-item ${hasSubMenuLV1Items && 'menu-item-submenu'} ${hasSubMenuLV1Items &&
                    item?.path?.length > 0 &&
                    pathName.includes(item.path) &&
                    'menu-item-open'
                    } ${!hasSubMenuLV1Items &&
                    item?.path?.length > 0 &&
                    pathName.includes(item.path) &&
                    'menu-item-active'
                    }`}
                >
                  <Link
                    to={item?.path}
                    onClick={(e) => {
                      if (Utils.checkFullUrl(item?.path)) {
                        e.preventDefault();
                        Utils.openInNewTab(item?.path);
                      }
                    }}
                    className={`menu-link ${hasSubMenuLV1Items && 'menu-toggle'}`}
                  >
                    <span className="sgv-icon menu-icon">
                      <div className='text-white'> {item?.icon}</div>
                      {/* <i className={`${item?.icon} text-white`} /> */}
                    </span>
                    <span className="menu-text">{t(item?.text)}</span>
                    {item?.label && (
                      <span className="menu-label">
                        <span className="label label-rounded label-danger label-inline">
                          {item?.label}
                        </span>
                      </span>
                    )}
                    {hasSubMenuLV1Items && <i className="menu-arrow" />}
                  </Link>
                  {/* Sub menu items level 1 */}
                  {hasSubMenuLV1Items && (
                    <div className="menu-submenu">
                      <ul className="menu-subnav">
                        {item?.subMenuItems?.map((subItemLV1, subIndexLV1) => {
                          const hasSubMenuLV2Items = subItemLV1?.subMenuItems !== undefined;
                          return (
                            (screenCodes.includes(subItemLV1.path) || screenCodes.includes("*")) ?
                              <li
                                key={subIndexLV1}
                                className={`menu-item ${hasSubMenuLV2Items && 'menu-item-submenu'} ${hasSubMenuLV2Items &&
                                  subItemLV1.path.length > 0 &&
                                  pathName.includes(subItemLV1.path) &&
                                  'menu-item-open'
                                  } ${!hasSubMenuLV2Items &&
                                  subItemLV1.path.length > 0 &&
                                  pathName.includes(subItemLV1.path) &&
                                  'menu-item-active'
                                  }`}
                              >
                                <Link
                                  className={`menu-link rounded-0 ${hasSubMenuLV2Items && 'menu-toggle'
                                    }`}
                                  to={subItemLV1?.path}
                                >
                                  <i className="menu-bullet menu-bullet-dot">
                                    <span></span>
                                  </i>
                                  <span className={`menu-text 
                                ` }>
                                    {t(subItemLV1?.text)}
                                  </span>
                                  {subItemLV1?.label && (
                                    <span className="menu-label">
                                      <span className="label label-rounded label-danger label-inline">
                                        {subItemLV1?.label}
                                      </span>
                                    </span>
                                  )}
                                  {hasSubMenuLV2Items && <i className="menu-arrow" />}
                                </Link>
                                {/* Sub menu items level 2 */}
                                {hasSubMenuLV2Items && (
                                  <div className="menu-submenu">
                                    <ul className="menu-subnav">
                                      {subItemLV1?.subMenuItems?.map((subItemLV2, subIndexLV2) => {
                                        const hasSubMenuLV3Items =
                                          subItemLV2?.subMenuItems !== undefined;

                                        return (
                                          <li
                                            key={subIndexLV2}
                                            className={`menu-item ${hasSubMenuLV3Items && 'menu-item-submenu'
                                              } ${hasSubMenuLV3Items &&
                                              subItemLV2.path.length > 0 &&
                                              pathName.includes(subItemLV2.path) &&
                                              'menu-item-open'
                                              } ${!hasSubMenuLV3Items &&
                                              subItemLV2.path.length > 0 &&
                                              pathName.includes(subItemLV2.path) &&
                                              'menu-item-active'
                                              }`}
                                          >
                                            <Link
                                              className={`menu-link rounded-0 ${hasSubMenuLV3Items && 'menu-toggle'
                                                }`}
                                              to={subItemLV2?.path}
                                            >
                                              <i className="menu-bullet menu-bullet-dot">
                                                <span></span>
                                              </i>
                                              <span className="menu-text">{t(subItemLV2?.text)}</span>
                                              {subItemLV2?.label && (
                                                <span className="menu-label">
                                                  <span className="label label-rounded label-danger label-inline">
                                                    {subItemLV2?.label}
                                                  </span>
                                                </span>
                                              )}
                                              {hasSubMenuLV3Items && <i className="menu-arrow" />}
                                            </Link>
                                            {/* Sub menu items level 3 */}
                                            {hasSubMenuLV3Items && (
                                              <div className="menu-submenu">
                                                <ul className="menu-subnav">
                                                  {subItemLV2?.subMenuItems?.map(
                                                    (subItemLV3, subIndexLV3) => {
                                                      const hasSubMenuLV4Items =
                                                        subItemLV3?.subMenuItems !== undefined;

                                                      return (
                                                        <li
                                                          key={subIndexLV3}
                                                          className={`menu-item ${hasSubMenuLV4Items && 'menu-item-submenu'
                                                            } ${hasSubMenuLV4Items &&
                                                            subItemLV3.path.length > 0 &&
                                                            pathName.includes(subItemLV3.path) &&
                                                            'menu-item-open'
                                                            } ${!hasSubMenuLV4Items &&
                                                            subItemLV3.path.length > 0 &&
                                                            pathName.includes(subItemLV3.path) &&
                                                            'menu-item-active'
                                                            }`}
                                                        >
                                                          <Link
                                                            className={`menu-link rounded-0 ${hasSubMenuLV4Items && 'menu-toggle'
                                                              }`}
                                                            to={subItemLV3?.path}
                                                          >
                                                            <i className="menu-bullet menu-bullet-dot">
                                                              <span></span>
                                                            </i>
                                                            <span className="menu-text">
                                                              {t(subItemLV3?.text)}
                                                            </span>
                                                            {subItemLV3?.label && (
                                                              <span className="menu-label">
                                                                <span className="label label-rounded label-danger label-inline">
                                                                  {subItemLV3?.label}
                                                                </span>
                                                              </span>
                                                            )}
                                                            {hasSubMenuLV4Items && (
                                                              <i className="menu-arrow" />
                                                            )}
                                                          </Link>
                                                          {/* Sub menu items level 4 */}
                                                        </li>
                                                      );
                                                    }
                                                  )}
                                                </ul>
                                              </div>
                                            )}
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  </div>
                                )}
                              </li>
                              : null
                          );
                        })}
                      </ul>
                    </div>
                  )}
                </li>
              );
            }

            // Section
            if (item?.type === 'section' && (items.includes(item?.item) || screenCodes.includes("*"))) {
              return (
                <li key={index} className="menu-section mt-0">
                  <h4 className="menu-text">{t(item?.text)}</h4>
                </li>
              );
            }
          })}
        </ul>
      </div>
    </div>
  );
}

export default KT01Sidebar;
